import { Link } from 'react-router-dom'
import './notfound.css'

export function NotFoundPage() {
  return (
    <div className="notfound">
      <div className="notfound__card">
        <span className="notfound__badge">404</span>
        <h2>Page Not Found</h2>
        <p>ไม่พบหน้าที่คุณต้องการเปิดใช้งาน หรือที่อยู่นี้อาจไม่ถูกต้อง</p>
        <p className="notfound__hint">
          กรุณาตรวจสอบลิงก์อีกครั้ง หรือกลับไปยังหน้าเข้าสู่ระบบเพื่อเริ่มใช้งานระบบใหม่
        </p>
        <div className="notfound__actions">
          <Link to="/login" className="notfound__button notfound__button--primary">
            กลับไปหน้า Login
          </Link>
          <button
            type="button"
            className="notfound__button notfound__button--secondary"
            onClick={() => window.history.back()}
          >
            กลับหน้าก่อนหน้า
          </button>
        </div>
      </div>
    </div>
  )
}
